import { Spacing } from '../theming';
import { css } from 'styled-components';
export var BASE_STYLES = css(["max-width:100%;"]);
export var BASE_SPACING = Spacing.Small;
export var Justification = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around'
};
export var Alignment = {
  Center: 'center',
  FlexStart: 'flex-start',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
  Stretch: 'stretch'
};